"use client";

import dynamic from "next/dynamic";
import { GlobalErrorBoundary } from "../components/GlobalErrorBoundary";

/**
 * Static loading shell rendered into the prerendered HTML (the dynamic AppShell
 * below is client-only, so without this nothing "contentful" paints until the JS
 * bundle executes — which on throttled mobile means FCP/LCP land at 2.5s+).
 *
 * It paints the logo (the LCP element) immediately, positioned to match each real
 * header — centred on mobile, top-left on desktop — so the hand-off to
 * AppShell doesn't shift layout (CLS stays 0). Mobile's real chrome no
 * longer has a persistent header of its own (Task 9 removed it in favor of
 * the top bar + drawer), so this loading shell's centred mobile block is
 * the only "header" mobile ever visually shows before/around hand-off.
 */
function AppShellLoading() {
  return (
    <div className="h-full w-full bg-ocean-900">
      {/* Mobile: centred top header */}
      <div className="flex items-center justify-center gap-2 pt-3 md:hidden">
        <img
          src="/logo.webp"
          alt="PodLog"
          width={224}
          height={80}
          fetchPriority="high"
          className="h-8 w-auto object-contain drop-shadow"
        />
        <h1 className="text-xs text-sky-200/70 font-normal m-0">UK coastal tracker</h1>
      </div>
      {/* Desktop: top-left header */}
      <header className="absolute left-4 top-4 z-10 hidden max-w-xs md:block">
        <img
          src="/logo.webp"
          alt="PodLog"
          width={224}
          height={80}
          fetchPriority="high"
          className="h-10 w-auto object-contain drop-shadow-md"
        />
        <h1 className="mt-1 text-xs text-sky-200/70 drop-shadow font-normal m-0">
          UK coastal cetacean tracker — live pods &amp; 24-hour forecast
        </h1>
      </header>
    </div>
  );
}

const AppShell = dynamic(() => import("../components/AppShell"), {
  ssr: false,
  loading: () => <AppShellLoading />,
});

export default function Home() {
  return (
    <main className="relative h-[100dvh] w-full overflow-hidden bg-ocean-900">
      <GlobalErrorBoundary>
        <AppShell />
      </GlobalErrorBoundary>
    </main>
  );
}
